/** BrightLocal marketing site terms-and-conditions page — linked from sign-up and the Citation Builder checkout. */
export const TERMS_AND_CONDITIONS_URL = 'https://www.brightlocal.com/terms-and-conditions/';
